import { render } from "./PatientCardSummary.vue?vue&type=template&id=5fcfbe2e"
import script from "./PatientCardSummary.vue?vue&type=script&lang=js"
export * from "./PatientCardSummary.vue?vue&type=script&lang=js"

import "./PatientCardSummary.vue?vue&type=style&index=0&id=5fcfbe2e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__